import { render, staticRenderFns } from "./TransportListStatistica.vue?vue&type=template&id=331ea756&scoped=true&"
import script from "./TransportListStatistica.vue?vue&type=script&lang=js&"
export * from "./TransportListStatistica.vue?vue&type=script&lang=js&"
import style0 from "./TransportListStatistica.vue?vue&type=style&index=0&id=331ea756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ea756",
  null
  
)

export default component.exports